"use client";
import "./index.es44.js";
import t, { useState as v, useMemo as x } from "react";
import "./index.es46.js";
import "./index.es47.js";
import "./index.es48.js";
import "./index.es49.js";
import "./index.es50.js";
import "./index.es51.js";
import M from "./index.es56.js";
import O from "styled-components";
import { toExcelIndicatorGroupsData as b } from "./index.es4.js";
import w from "./index.es57.js";
import _ from "./index.es58.js";
const g = O.div`
  .bl-accordion .bl-accordion__content {
    padding-top: 8px;
    padding-bottom: 32px;
  }
`, S = ({
  indicatorGroups: o,
  primaryRegion: c,
  comparisonRegions: i,
  regionsData: l,
  indicatorValues: s,
  details: r,
  compareScope: d,
  categories: f,
  slug: p
}) => {
  const [m, a] = v(
    o?.[0] ? [o[0].id] : []
  ), n = x(
    () => r ? b(r, o, l) : null,
    [r, o, l]
  ), E = (e) => () => {
    m.includes(e) ? a(m.filter((u) => u !== e)) : a([...m, e]);
  };
  return /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(g, null, o.map((e) => /* @__PURE__ */ t.createElement(
    M,
    {
      key: `group-${e.id}`,
      contentId: `group-${e.id}`,
      header: e.title,
      isOpen: m.includes(e.id),
      onClick: E(e.id)
    },
    /* @__PURE__ */ t.createElement(
      _,
      {
        categories: f,
        compareScope: d,
        comparisonRegions: i,
        indicatorGroup: e,
        indicatorValues: s,
        primaryRegion: c,
        slug: p
      }
    )
  ))), n && /* @__PURE__ */ t.createElement("div", { className: "bl-m-t-3" }, /* @__PURE__ */ t.createElement(
    w,
    {
      data: n.data,
      sheets: n.sheets,
      fileName: `${p}.xlsx`
    }
  )));
};
export {
  S as default
};
//# sourceMappingURL=index.es36.js.map
